<script lang="ts">
	import { trackEvent } from '$lib/segment/client';
	import Blok from '$lib/storyblok/blok.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			question: string;
			description: string;
			answers: Array<ISbStoryData['content']>;
			randomize_answer_order?: boolean;
		}>['content'];
		oncontinue?: () => void;
		active?: boolean;
	}

	let { content, oncontinue, active = false }: Props = $props();
	let { randomize_answer_order = true, question, description, answers = [] } = content;

	let selected: null | number = $state(null);

	let choices = $derived(
		randomize_answer_order ? [...answers].sort(() => Math.random() - 0.5) : answers
	);

	function onChange(event: any) {
		selected = parseInt(event.currentTarget?.value?.split('|')[0], 10);

		trackEvent(`Quiz next step clicked`, {
			question,
			description,
			choices,
			selectedAnswer: selected
		});
		oncontinue?.();
	}
</script>

<section
	use:editable={content}
	class={[
		'scrollbar-hide relative h-full w-full overflow-y-auto bg-white text-center',
		{ hidden: !active }
	]}
>
	<div class="text-balance">
		<h1 class="text-balance font-rhymes text-[32px]/[120%] tracking-[-.32px]">
			{question}
		</h1>

		{#if description?.length}
			<p class="mt-2 text-balance text-[14px]/[160%] lg:mt-3 lg:text-[16px]/[150%]">
				{description}
			</p>
		{/if}

		<div class="mt-8 flex flex-col gap-y-3 lg:gap-y-4">
			{#each choices as block, index}
				<label class="answer-label flex cursor-pointer">
					<input
						checked={selected === index}
						onclick={onChange}
						class="w-0 appearance-none"
						type="radio"
						name="answerIndex"
						value={`${index}|${answers.findIndex((answer) => answer._uid === block._uid)}`}
					/>
					<div
						class={[
							'w-full rounded-2xl border p-4 text-[14px]/[160%] transition-colors',
							selected === index
								? 'border-orange-peach bg-[#FFE8C8]'
								: 'border-brown-5 bg-brown-6 lg:hover:border-orange-peach'
						]}
					>
						<Blok content={block} />
					</div>
				</label>
			{/each}
		</div>
	</div>
</section>
